import request from '@/utils/request'

// 查询列表
export function apiBomOperationList (query) {
  return request({
    url: '/bom/bomOperation/list',
    method: 'get',
    params: query
  })
}

// 导出列表
export function apiBomOperationNewExport (data) {
  return request({
    url: '/bom/bomOperation/v2/export',
    method: 'post',
    data: data
  })
}

// 工序编码
export function apiBomOperationFindList (query) {
  return request({
    url: '/bom/bomOperation/findList',
    method: 'get',
    params: query
  })
}

// 修改
export function apiBomOperationUpdate (data) {
  return request({
    url: '/bom/bomOperation',
    method: 'put',
    data: data
  })
}

// 新增
export function apiBomOperationAdd (data) {
  return request({
    url: '/bom/bomOperation',
    method: 'post',
    data: data
  })
}
